module.exports = __webpack_public_path__ + "img/edit_related.d8b6dc3e.svg";